import {TableIcon} from '@primer/octicons-react'
import {Link, Octicon} from '@primer/react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants'

import type {RemovedFromProjectEvent$key} from './__generated__/RemovedFromProjectEvent.graphql'
import {TimelineRow} from './row/TimelineRow'
import {createIssueEventExternalUrl} from '../utils/urls'

type RemovedFromProjectEventProps = {
  queryRef: RemovedFromProjectEvent$key
  issueUrl: string
  highlightedEventId?: string
  refAttribute?: React.MutableRefObject<HTMLDivElement | null>
}

export function RemovedFromProjectEvent({
  queryRef,
  issueUrl,
  highlightedEventId,
  refAttribute,
}: RemovedFromProjectEventProps): JSX.Element {
  const {actor, createdAt, project, projectColumnName, databaseId} = useFragment(
    graphql`
      fragment RemovedFromProjectEvent on RemovedFromProjectEvent {
        createdAt
        databaseId
        actor {
          ...EventActor
          ...EventActorAvatarItemBadge
        }
        project {
          name
          url
        }
        projectColumnName
      }
    `,
    queryRef,
  )

  if (!project) {
    return <></>
  }
  const highlighted = String(databaseId) === highlightedEventId
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      actorAvatar={actor}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
    >
      <>
        {`${LABELS.timeline.removedThisFrom} ${projectColumnName} in `}
        <Octicon icon={TableIcon} />{' '}
        <Link href={project.url} sx={{color: 'fg.default', mr: 1}}>
          {project.name}
        </Link>
      </>
    </TimelineRow>
  )
}

try{ RemovedFromProjectEvent.displayName ||= 'RemovedFromProjectEvent' } catch {}